module.exports = __webpack_public_path__ + "static/media/caret_down_gray.ed3ab124.svg";